import { render, staticRenderFns } from "./JobPeopleAndRoleListing.vue?vue&type=template&id=fd156ad8&"
import script from "./JobPeopleAndRoleListing.vue?vue&type=script&lang=js&"
export * from "./JobPeopleAndRoleListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports